enum FeatureFlag {
  AgenticProcessByHooks = 'agentic_process_by_hooks',
  AiInsights = 'ai_insights',
  CorporateGoals = 'corporate_goals',
  EnableFloraDarkMode = 'enable_flora_dark_mode',
  FloraAutoMode = 'flora_auto_mode',
  FloraSlackIntegration = 'flora_slack_integration',
  FloraTeamsIntegration = 'flora_teams_integration',
  StrategyOverview = 'strategy_overview',
  SyntheticProjects = 'synthetic_projects',
  InitiativeCommittedFilter = 'initiative_committed_filter',
  CustomCurrency = 'custom_currency',
  RbacEnabled = 'rbac_enabled',
  RiskInsights = 'risk_insights',
  IntegrationHealthChecker = 'integration_health_checker',
  UnifiedProcessGraph = 'unified_process_graph',
}

export { FeatureFlag };
